import React from 'react';
import { FaIndustry, FaCogs, FaNetworkWired } from 'react-icons/fa'; // Different icons for engineering categories

const ServiceCard = ({ icon, title }) => {
    return (
        <div className="service-card">
            <div className="service-icon">
                {icon}
            </div>
            <h3>{title}</h3>

            <style jsx>{`
                .service-card {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #fff;
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    padding: 20px;
                    width: 350px; /* Increased width */
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                    margin: 10px;
                    transition: transform 0.3s ease;
                    cursor: pointer;
                }

                .service-card:hover {
                    transform: scale(1.05);
                }

                .service-icon {
                    font-size: 40px;
                    margin-right: 10px;
                    color: #11A1B0;
                }

                h3 {
                    margin: 0;
                    font-size: 18px;
                    color: #333;
                }
            `}</style>
        </div>
    );
};

const Aboutuservices = () => {
    const serviceData = [
        {
            id: 1,
            title: 'Plant Engineering',
            icon: <FaIndustry />,
        },
        {
            id: 2,
            title: 'Product Engineering',
            icon: <FaCogs />,
        },
        {
            id: 3,
            title: 'Network Engineering',
            icon: <FaNetworkWired />,
        },
    ];

    return (
        <div className="services-container">
            <h2><span style={{color:'#000'}}>Our</span> Services</h2>
            <div className="service-cards-wrapper">
                {serviceData.map((service) => (
                    <ServiceCard key={service.id} title={service.title} icon={service.icon} />
                ))}
            </div>

            <style jsx>{`
                .services-container {
                    text-align: center;
                    padding: 40px 20px;
                    background: #fff;
                }

                h2 {
                    font-size: 32px;
                    margin-bottom: 20px;
                    color: #11A1B0;
                }

                .service-cards-wrapper {
                    display: flex;
                    justify-content: center;
                    gap: 20px;
                    flex-wrap: wrap;
                    margin-top: 30px;
                }
            `}</style>
        </div>
    );
};

export default Aboutuservices;
